import graphql from "babel-plugin-relay/macro";

const WalletTransactionHistoryByBalanceTypeQuery = graphql`
    query WalletTransactionHistoryByBalanceTypeQuery($balanceType: BalaneTypesEnum) {
        walletTransactionsFilter(balanceType:$balanceType)
        {
           edges{
              node{
                id
                transactionType
                amount
                created
                cashType
                description
              }
           }
        }
    }
`;

export default WalletTransactionHistoryByBalanceTypeQuery;